<template>
  <div id="swing_hand">
    <!-- <error-page message="ระบบบกำลังอยู่ในระหว่างการพัฒนา"></error-page> -->
    <transition name="fade" mode="out-in">
      <div
        class="loading"
        style="height: 100vh; background: orange"
        v-if="loading"
        key="loading"
      >
        <pulse-loader
          color="#ffffff"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -28.5px;
            margin-top: -12px;
          "
        ></pulse-loader>
      </div>
      <div v-else-if="showDeviceNotSupport">
        <error-page message="Your device is not support"></error-page>
      </div>
      <div v-else-if="line_error">
        <error-page></error-page>
      </div>
      <div
        v-else
        key="cotent"
        style="overflow-x: hidden; max-width: 380px; width: 100%; margin: auto"
      >
        <div
          id="standby"
          class="text-center"
          v-show="state == 'welcome'"
          style="background-color: #ffc57b; min-height: 100vh"
        >
          <div
            :style="{
              'background-image': 'url(./img/exercise/bg_exercise.png)',
            }"
            style="
              width: 100%;
              background-size: cover;
              background-repeat: no-repeat;
              background-position: center;
            "
          >
            <img
              :src="'./img/exercise/tuinui_swing_hand.gif'"
              alt=""
              style="margin-top: 140px"
            />
          </div>
          <div style="padding-top: 45px; padding-bottom: 45px">
            <a
              href="javascript:void(0);"
              style="width: 220px"
              class="btn btn-primary btn-lg"
              @click="showTutorial = true"
              ><img
                :src="'./img/exercise/play_icon.png'"
                alt=""
                style="width: 40px; margin-right: 10px"
              />Play Game</a
            ><br /><br />
            <a
              href="javascript:void(0);"
              style="width: 220px"
              class="btn btn-primary btn-lg"
              @click="showReward = true"
              ><img
                :src="'./img/exercise/rewards_icon.png'"
                alt=""
                style="width: 40px; margin-right: 15px"
              />Rewards</a
            >
          </div>
        </div>

        <div
          class="running"
          v-show="state == 'running'"
          style="
            position: relative;
            min-height: 100vh;
            background-color: #fff294;
          "
        >
          <transition enter-active-class="animated fadeIn">
            <div
              class="overlay"
              v-if="showResult"
              style="
                width: 100%;
                height: 100%;
                position: absolute;
                background: #0000005c;
                z-index: 300;
              "
            >
              <div
                class="text-center"
                style="position: absolute; margin-top: 50px; width: 100%"
              >
                <div style="height: 70px">
                  <transition enter-active-class="animated tada"> </transition>
                </div>
                <transition enter-active-class="animated fadeIn">
                  <div>
                    <div
                      style="
                        background: white;
                        padding: 32px 10px;
                        margin: 15px 0;
                      "
                    >
                      <div style="margin-bottom: 25px" v-if="eatmore">
                        <p style="margin: 0">คุณสามารถกินได้อีก</p>
                        <img
                          :src="'./img/exercise/food_icon.png'"
                          style="width: 100px"
                          alt=""
                        />
                        <span style="font-size: 32px">+1</span>
                      </div>
                      <p style="margin: 0">พลังงานสะสมที่เผาผลาญได้</p>
                      <h1
                        style="
                          margin: 0;
                          margin-top: 10px;
                          color: orange;
                          background: #eee;
                          padding: 10px;
                          border-radius: 5px;
                          max-width: 300px;
                          margin: auto;
                          margin-top: 5px;
                        "
                      >
                        {{ caldecrease | numberFormat
                        }}<span
                          style="
                            margin-left: 5px;
                            font-size: 15px;
                            color: black;
                          "
                          >kcal</span
                        >
                      </h1>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="btn btn-blue btn-lg"
                      @click="resetSwing"
                      ><img
                        :src="'./img/battle/mainmenu_icon.png'"
                        alt=""
                        style="width: 50px"
                      />
                      Main Menu</a
                    >
                  </div>
                </transition>
              </div>
            </div>
          </transition>

          <img
            ref="game_bg"
            :src="'./img/exercise/bg_swing.png'"
            alt=""
            style="width: 100%"
          />
          <div
            style="
              position: absolute;
              width: 100%;
              top: 0;
              left: 0;
              text-align: center;
              color: white;
            "
          >
            <transition
              enter-active-class="animated fadeIn"
              leave-active-class="animated fadeOut"
            >
              <div
                v-show="showCountDown"
                class="text-center"
                style="
                  background: orange;
                  border-radius: 50%;
                  width: 250px;
                  height: 250px;
                  background-repeat: no-repeat;
                  background-size: cover;
                  background-position: center;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  margin-left: -125px;
                  margin-top: -125px;
                  z-index: 100;
                "
              >
                <transition-group
                  enter-active-class="animated tada"
                  :duration="{ enter: 1000 }"
                >
                  <img
                    v-show="step == 0"
                    key="step_go"
                    :src="'./img/exercise/go.png'"
                    style="
                      width: 160px;
                      margin-top: -90px;
                      top: 50%;
                      position: absolute;
                      margin-left: -80px;
                    "
                  />
                  <img
                    v-show="step == 1"
                    key="step_1"
                    :src="'./img/exercise/1.png'"
                    style="
                      width: 160px;
                      margin-top: -90px;
                      top: 50%;
                      position: absolute;
                      margin-left: -80px;
                    "
                  />
                  <img
                    v-show="step == 2"
                    key="step_2"
                    :src="'./img/exercise/2.png'"
                    style="
                      width: 160px;
                      margin-top: -90px;
                      top: 50%;
                      position: absolute;
                      margin-left: -80px;
                    "
                  />
                  <img
                    v-show="step == 3"
                    key="step_3"
                    :src="'./img/exercise/3.png'"
                    style="
                      width: 160px;
                      margin-top: -90px;
                      top: 50%;
                      position: absolute;
                      margin-left: -80px;
                    "
                  />
                </transition-group>
              </div>
            </transition>

            <p style="margin-top: 15px; margin-bottom: 0; color: black">Time</p>
            <h1 style="margin-top: 0; color: black">
              {{ time }}
            </h1>

            <!-- <p style="color: black">{{gamma}}</p> -->
            <div
              style="
                border-radius: 50%;
                background: orange;
                width: 100px;
                margin: auto;
                height: 100px;
                padding-top: 5px;
                margin-top: 115px;
                overflow: hidden;
              "
            >
              <h1 style="margin-top: 25px; margin-bottom: 0px">
                {{ count }}
              </h1>
            </div>

            <img :src="'./img/exercise/tuinui_swing_hand.gif'" alt="" />
          </div>
        </div>
      </div>
    </transition>

    <modal-dialog v-if="showTutorial" @close="showTutorial = false">
      <div slot="header"></div>

      <div slot="body">
        <h3 class="text-center" style="margin-top: 0px; margin-bottom: 15px">
          แกว่งแขนไปกับตุ้ยนุ้ยกัน
        </h3>
        <ol style="padding-left: 20px; padding-right: 20px">
          <li style="padding-bottom: 15px">
            กางขาออกให้กว้างเท่ากับช่วงไหล่
            <img
              :src="'./img/exercise/step_1.png'"
              style="max-width: 200px; margin: auto"
              alt=""
              class="img-responsive"
            />
          </li>
          <li style="padding-bottom: 15px">
            คว่ำมือลง ออกแรงแกว่งแขนไปด้านหลังและหายใจออก
            <img
              :src="'./img/exercise/step_2.png'"
              style="max-width: 200px; margin: auto"
              alt=""
              class="img-responsive"
            />
          </li>
          <li style="padding-bottom: 15px">
            และปล่อยแขนกลับไปด้านหน้าสบายๆ
            <img
              :src="'./img/exercise/step_3.png'"
              style="max-width: 200px; margin: auto"
              alt=""
              class="img-responsive"
            />
          </li>
        </ol>
      </div>

      <div class="text-center" slot="footer">
        <button class="btn btn-primary btn-lg" @click="onStartRunning">
          Play
        </button>
      </div>
    </modal-dialog>

    <modal-dialog v-if="showReward" @close="showReward = false">
      <div slot="header"></div>

      <div slot="body">
        <ol style="padding-left: 20px; padding-right: 20px">
          <li>
            <b>รางวัลภายในเกม</b>
            <p>
              แกว่งแขนตามตุ้ยนุ้ยครบ 2 นาที
              จะทำให้ตุ้ยนุ้ยลดแคลอรี่ตามจำนวนที่สามารถแกว่งแขนได้
              และจะทำให้ตุ้ยนุ้ยกินอาหารเพิ่มได้ 1 ครั้ง เมื่อแกว่งแขนเกิน 35
              ครั้งขึ้นไป
            </p>
          </li>

          <li>
            <b>รางวัลภายนอกเกม</b>
            <p>
              ควรแกว่งต่อเนื่อง 10 นาทีต่อครั้ง ในหนึ่งวันควรแกว่งให้ได้ทั้งหมด
              30 นาที และ 5 วันต่อสัปดาห์
              ทำควบคู่กับการควบคุมอาหารจะมีประโยชน์ดังต่อไปนี้
            </p>
            <ul>
              <li>ลดการสะสมไขมันที่บริเวรพุง</li>
              <li>ลดความดันโลหิตสูง</li>
              <li>ลดอาการปวดบ่า คอ ไหล่ เวลาทำงาน</li>
            </ul>
          </li>
        </ol>
      </div>

      <div class="text-center" slot="footer">
        <button class="btn btn-primary btn-lg" @click="showReward = false">
          Close
        </button>
      </div>
    </modal-dialog>
  </div>
</template>

<script>
import ErrorPage from "@/views/components/ErrorPage.vue";
import $ from "jquery";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import ModalDialog from "@/views/components/ModalDialog";

import TuinuiJson from "@/assets/json/swing_sprite_array.json";

var Shake = require("shake.js");

export default {
  data: function () {
    return {
      isAndroid: false,
      userid: null, //U15dcdd6825d0efae99fb8f144ed7cfd1
      loading: true,
      line_error: false,
      state: "welcome",
      step: 4,
      count: 0,
      time: 120,
      position: 0,
      interval: 100,
      tuinui: null,
      tuinuiSpriteArray: TuinuiJson,
      showTutorial: false,
      showReward: false,
      showCountDown: false,
      showDeviceNotSupport: false,
      showResult: false,
      max: 50,
      gamma: 0,
      coords: {
        x: [],
        y: [],
        z: [],
      },
      gap: 7,
      running: true,
      deltaTime: true,
      delta: 0,
      delay: 1000,
      pauseShake: false,
      caldecrease: 0,
      eatmore: false,
      shakeEvent: null,
      orientationStep: 1,
    };
  },
  components: {
    ErrorPage,
    PulseLoader,
    ModalDialog,
  },
  mounted: async function () {
    var vm = this;
    var device = /android/i.test(navigator.userAgent.toLowerCase());
    vm.isAndroid = device;
    if (!window.DeviceOrientationEvent || !window.DeviceMotionEvent) {
      vm.showDeviceNotSupport = true;
    }

    this.loading = true;

    try {
      await this.$liff.init({
        liffId: process.env.VUE_APP_LIFF_ID_EXERCISE, // Use own liffId
      });
      if (this.$liff.isLoggedIn()) {
        const profile = await this.$liff.getProfile();
        this.display_name = profile.displayName;
        this.userid = profile.userId;

        this.loading = false;
      } else this.$liff.login();
    } catch (error) {
      this.line_error = true;
    }
    this.loading = false;
  },
  methods: {
    init: function () {
      // vm.$refs.tuinui.style.backgroundPosition = '-256px 0px';
    },
    onStartRunning: function () {
      var vm = this;
      vm.state = "running";
      vm.showTutorial = false;

      setTimeout(() => {
        var count = 4;
        setTimeout(() => {
          vm.showCountDown = true;
          var timer = setInterval(function () {
            if (count == -1) {
              vm.showCountDown = false;
              clearInterval(timer);
              vm.onRunning();
            } else {
              //
            }
            vm.step = count;
            count--;
          }, 1000);
        }, 1000);
      }, 300);
    },
    onRunning: function () {
      var vm = this;
      vm.count = 0;
      vm.startShake();

      var game = setInterval(function () {
        vm.time -= 1;
        if (vm.time <= 0) {
          vm.running = false;
          if (vm.isAndroid && vm.shakeEvent != null) {
            vm.shakeEvent.stop();
          }
          vm.calculateCalories(function () {
            vm.showResult = true;
          });
          clearInterval(game);
        }
      }, 1000);
      // Velocity(vm.$refs.game_bg,{ translateX: '-' + 300 + 'px' },{duration: 60000})
    },
    startShake: function () {
      var vm = this;

      if (vm.isAndroid) {
        if (window.DeviceOrientationEvent) {
          window.addEventListener(
            "deviceorientation",
            vm.deviceOrientationListener
          );
        } else {
          vm.shakeEvent = new Shake({
            threshold: 15, // optional shake strength threshold
            timeout: 1000, // optional, determines the frequency of event generation
          });

          vm.shakeEvent.start();

          window.addEventListener("shake", this.onShake, false);
        }
      } else {
        var coords = {
            x: [],
            y: [],
            z: [],
          },
          initTime = true;
        var e = null;

        for (var i = 160; i--; ) {
          coords.x.push(0);
          coords.y.push(0);
          coords.z.push(0);
        }

        if (window.DeviceMotionEvent) {
          // alert("DeviceMotionEvent supported");
          window.addEventListener(
            "devicemotion",
            function (ev) {
              if (!vm.running) {
                return false;
              }

              e = ev.acceleration || ev.accelerationIncludingGravity;

              if (!initTime) {
                initTime = ev.timeStamp;
              } else if (initTime != "ok") {
                vm.delta = (ev.timeStamp - initTime) / 1000 + "s";
                vm.deltaTime = (ev.timeStamp - initTime) / 1000;
                initTime = ev.timeStamp;
              }

              var obj = {};
              for (var key in e) {
                if (typeof e[key] == "number") {
                  var n = Math.round(e[key] * 10) / 10;
                  r = (n >= 0 ? "+" : "") + n;
                } else {
                  var r = typeof e[key];
                }
                obj[key] = r;
                if (vm.max <= vm.coords[key].length) {
                  vm.coords[key] = vm.coords[key].slice(1);
                }
                if (!ev.acceleration && key == "z") {
                  vm.coords[key].push(9.86 - n);
                } else {
                  vm.coords[key].push(e[key]);
                }
              }
              if (vm.coords["z"].length > 2) {
                if (!vm.pauseShake) {
                  vm.y = Math.abs(
                    vm.coords["z"][vm.coords["z"].length - 1] -
                      vm.coords["z"][vm.coords["z"].length - 2]
                  ).toFixed(2);
                  if (
                    Math.abs(
                      vm.coords["z"][vm.coords["z"].length - 1] -
                        vm.coords["z"][vm.coords["z"].length - 2]
                    ) >= vm.gap
                  ) {
                    vm.count++;
                    vm.coords = {
                      x: [],
                      y: [],
                      z: [],
                    };
                    vm.pauseShake = true;
                    setTimeout(() => {
                      vm.pauseShake = false;
                    }, vm.delay);
                  }
                }
              }
            },
            false
          );
        } else {
          vm.showDeviceNotSupport = true;
        }
      }
    },
    deviceOrientationListener: function (event) {
      var vm = this;
      if (!vm.running) {
        return false;
      }
      // vm.gamma = vm.orientationStep + ',' + Math.abs(Math.round(event.gamma))

      if (vm.max <= vm.coords["z"].length) {
        vm.coords["z"] = vm.coords["z"].slice(1);
      }
      vm.coords["z"].push(Math.round(event.gamma));

      if (vm.coords["z"].length > 2) {
        if (!vm.pauseShake) {
          vm.gamma = Math.abs(
            vm.coords["z"][vm.coords["z"].length - 1] -
              vm.coords["z"][vm.coords["z"].length - 2]
          ).toFixed(2);
          if (
            Math.abs(
              vm.coords["z"][vm.coords["z"].length - 1] -
                vm.coords["z"][vm.coords["z"].length - 2]
            ) >= vm.gap
          ) {
            vm.count++;
            vm.coords = {
              x: [],
              y: [],
              z: [],
            };
            vm.pauseShake = true;
            setTimeout(() => {
              vm.pauseShake = false;
            }, vm.delay);
          }
        }
      }
    },
    onShake: function () {
      this.count++;
    },
    resetSwing: function () {
      var vm = this;
      vm.step = 4;
      vm.count = 0;
      vm.time = 120;
      vm.showTutorial = false;
      vm.showReward = false;
      vm.showCountDown = false;
      vm.showResult = false;
      vm.max = 50;
      vm.y = 0;
      (vm.coords = {
        x: [],
        y: [],
        z: [],
      }),
        (vm.gap = 7);
      vm.running = true;
      vm.deltaTime = true;
      vm.delta = 0;
      vm.delay = 500;
      vm.pauseShake = false;
      vm.state = "welcome";
      vm.caldecrease = 0;
      vm.eatmore = false;
      vm.orientationStep = 1;
      vm.shakeEvent = null;
    },
    calculateCalories: function (callback) {
      var vm = this;
      if (vm.count <= 0) {
        callback();
        return false;
      }
      const SERVER_URL = "https://caloriesbot.herokuapp.com/";
      var data = {
        userid: vm.userid + "__148369119115215",
        amount: vm.count >= 200 ? 200 : vm.count,
      };
      $.ajax({
        url: SERVER_URL + "updateexcercise",
        type: "POST",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (result) {
          if (result.responsecode == 200) {
            vm.eatmore = result.eatmore;
            vm.caldecrease = result.caldecrease;

            callback(result.data);
          } else {
            vm.line_error = true;
          }
        },
        error: function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          callback(null);
          vm.line_error = true;
        },
      });
    },
  },
  watch: {
    showTutorial: function (newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
    showReward: function (newVal) {
      if (newVal) {
        $("body").addClass("modal-open");
      } else {
        $("body").removeClass("modal-open");
      }
    },
  },
};
</script>

<style scoped></style>
